module.exports = __webpack_public_path__ + "img/goods_gg.c9285f85.svg";